import '../social_content_header_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents.InstagramBusinessListening'

class Monitoring.Views.SocialContents.InstagramBusinessListening.InstagramBusinessListeningHeaderView extends
      Monitoring.Views.SocialContents.SocialContentHeaderView

  initialize: (el, model) ->
    @model = model
    @$el = el

  normalizeSubType: ->
    _.str.humanize(@model.subType())
